const ToggleSwitch: React.FC<{
  onToggle: () => void;
  isChecked: boolean;
  className?: string;
}> = ({ isChecked, onToggle, className = "" }) => {
  return (
    <div
      className={`relative w-10 h-5 rounded-full cursor-pointer transition-colors duration-300 overflow-hidden
      ${isChecked ? "bg-green" : "bg-gray-300"} ${className}`}
      onClick={onToggle}
    >
      <div
        className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white transition-transform duration-300
        ${isChecked ? "translate-x-5" : "translate-x-0"}`}
      ></div>
    </div>
  );
};

export default ToggleSwitch;
